import { SpanKind, trace } from '@opentelemetry/api';

import { getTraceparentMetaContext } from '../resources';

export class Module {
  constructor(aggregator, config, otelConfig) {
    this.aggregator = aggregator;
    this.config = config;
    this.otelConfig = otelConfig;
    this.tracer = trace.getTracer(
      '__webMonitoringName__',
      '__webMonitoringVersion__',
    );
  }

  spanConfig(attributes) {
    return {
      kind: SpanKind.CLIENT,
      attributes,
    };
  }

  recordCustomSpan(name, events = [], attributes = {}, status = undefined) {
    try {
      const span = this.tracer.startSpan(
        `${name}`,
        this.spanConfig(attributes),
        getTraceparentMetaContext(false),
      );

      /* istanbul ignore next */
      if (status !== undefined) {
        span.setStatus(status);
      }

      /* istanbul ignore next */
      events.forEach((event) => {
        span.addEvent(event.name, event.attributes, event.startTime);
      });

      span.end();

      return true;
    } catch (e) {
      console.error(e);

      return false;
    }
  }

  recordSpan(name, events = [], attributes = {}, status = undefined) {
    try {
      return this.tracer.startActiveSpan(
        name,
        this.spanConfig(attributes),
        /* istanbul ignore next */
        (span) => {
          if (status !== undefined) {
            span.setStatus(status);
          }

          events.forEach((event) => {
            span.addEvent(event.name, event.attributes, event.startTime);
          });
          span.end();
        },
      );
    } catch (e) {
      console.error(e);

      return false;
    }
  }
}
